export default __webpack_public_path__ + "static/logo3-4750a77eda5b942d0b5260a0133fb95f.png";